import React from 'react';
import Icon from '../ui/Icon';

const activityIcons = {
  listing: 'home',
  agent: 'users',
  transaction: 'fileText'
};

const statusClasses = {
  active: 'badge-emerald',
  pending: 'badge-amber',
  sold: 'badge-blue',
  closed: 'badge-slate'
};

function formatDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
}

export default function RecentActivity({ activities = [] }) {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Recent Activity</h3>
      </div>
      <div className="card-content" style={{ padding: '1rem 1.5rem' }}>
        {activities.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '2rem 0', color: 'var(--slate-400)' }}>
            <Icon name="clock" size={32} style={{ margin: '0 auto 0.5rem', opacity: 0.5 }} />
            <p>No recent activity</p>
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            {activities.map((activity, idx) => (
              <div 
                key={idx} 
                className="flex items-start gap-4 p-3 rounded-lg transition"
                style={{ cursor: 'pointer' }}
                onMouseEnter={e => e.currentTarget.style.background = 'var(--slate-50)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                <div style={{ padding: '0.5rem', background: 'var(--slate-100)', borderRadius: '0.5rem' }}>
                  <Icon name={activityIcons[activity.type] || 'fileText'} size={16} style={{ color: 'var(--slate-600)' }} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-slate-900 truncate">
                    {activity.title}
                  </p>
                  <p className="text-xs text-slate-500">
                    {formatDate(activity.date)}
                  </p>
                </div>
                {activity.status && (
                  <span className={`badge ${statusClasses[activity.status] || 'badge-slate'}`}>
                    {activity.status}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}